'use client';

import { c as _c } from "react/compiler-runtime";
import { RegionFinderContent } from '@/app/donation/_components/RegionFinderContent';
import { useRegionFinder } from '@/app/donation/_hooks/useRegionFinder';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
interface RegionFinderDialogProps {
  opened: boolean;
  onClose: () => void;
}
export const RegionFinderDialog = t0 => {
  const $ = _c(15);
  const {
    opened,
    onClose
  } = t0;
  let t1;
  if ($[0] !== opened) {
    t1 = {
      enabled: opened
    };
    $[0] = opened;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const finder = useRegionFinder(t1);
  let t2;
  if ($[2] !== finder || $[3] !== onClose) {
    t2 = () => {
      finder.reset();
      onClose();
    };
    $[2] = finder;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClose = t2;
  let t3;
  if ($[5] !== finder || $[6] !== handleClose) {
    t3 = id => {
      handleClose();
      finder.handleSelectRegion(id);
    };
    $[5] = finder;
    $[6] = handleClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== finder || $[9] !== t3) {
    t4 = <div className="flex h-full flex-col xl:h-[70dvh]"><RegionFinderContent finder={finder} onSelect={t3} /></div>;
    $[8] = finder;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleClose || $[12] !== opened || $[13] !== t4) {
    t5 = <ResponsiveDialog isAppBarHeader={true} drawerNoPadding={true} modalHeader={"\uC9C0\uC5ED\uCC3E\uAE30"} opened={opened} onClose={handleClose} title={"\uC9C0\uC5ED\uCC3E\uAE30"}>{t4}</ResponsiveDialog>;
    $[11] = handleClose;
    $[12] = opened;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};